import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService {
parseHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // BehaviorSubject to emit subscription features when loaded
  private subscriptionFeaturesSubject = new BehaviorSubject<any>(null);
  public subscriptionFeatures$ = this.subscriptionFeaturesSubject.asObservable();

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {}

  public getFeatureFlagsFromApi(): void {
    const stored = localStorage.getItem('SubscriptionFeatures');

    if (stored) {
      const parsed = JSON.parse(stored);

      if (parsed.lastFetchedAt && !this.isCacheExpired(parsed.lastFetchedAt)) {
        //Using cached feature flags
        this.subscriptionFeaturesSubject.next(parsed);
        return;
      }
    }

    this.getSellerSubscriptionFeatures().subscribe((res: any) => {
      if (res?.Result === "Success" && res?.ResponseData) {
        let suscriptionFeatures = {};
        try{
          suscriptionFeatures = JSON.parse(res?.ResponseData);
        } catch (e){
          console.error('Invalid JSON in ResponseData:', res?.ResponseData, e);
          suscriptionFeatures = {};
        }
        const dataWithTimestamp = {
          ...suscriptionFeatures,
          lastFetchedAt: new Date().toISOString()
        };
        localStorage.setItem('SubscriptionFeatures', JSON.stringify(dataWithTimestamp));
        this.subscriptionFeaturesSubject.next(dataWithTimestamp);
      } else {
        console.warn('Subscription response not successful or missing data:', res);
      }
    },
      (err: any) => {
        console.error(err);
      }
    )
  }


  public getSellerSubscriptionFeatures() {
    const sendingData = {
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/GetFeaturesBySubscriptionPlan';
    return this.http.get(url, this.parseHeaders);
  }

  public getSubscriptionFeatures() {
    return JSON.parse(localStorage.getItem('SubscriptionFeatures') || '{}');
  }

  public setSubscriptionFeaturesIfAuthenticated(){
    const userDetails = this.configService.getLoginDetails();
    if (userDetails?.Uuid) {
      this.getFeatureFlagsFromApi();
    }
  }

  private isCacheExpired(lastFetchedAt: string): boolean {
    const lastTime = new Date(lastFetchedAt).getTime();
    const now = Date.now();
    const diffInMs = now - lastTime;

    const hours24 = 24 * 60 * 60 * 1000;
    return diffInMs > hours24;
  }

}
